// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"a1927c1e","240":"076c932d","470":"aab6aa76","703":"110ba723","807":"04aa1eb2"}[chunkId] + ".chunk.css";
};